module.exports = __webpack_public_path__ + "img/ccl_thumbnail.d008d37a.jpg";